import createStyles from "@mui/styles/createStyles";
import makeStyles from "@mui/styles/makeStyles";
import { OLTheme } from "contexts/Theme/ThemeProvider";

export const useStyles = makeStyles((theme: OLTheme) =>
  createStyles({
    header: {
      background: theme.gray50,
      borderRadius: "8px 8px 0 0",
      boxShadow: `0px 1px 0px ${theme.gray200}`,
      color: theme.gray800,
      padding: theme.spacing(6, 8),
    },
    left: {
      alignItems: "center",
      color: theme.gray500,
      display: "flex",
      gap: "5px",
      minWidth: "200px",
    },
    right: {
      color: theme.gray800,
      display: "flex",
      flexWrap: "wrap",
      gap: theme.spacing(6),
      textAlign: "right",
      "& #boxElement": {
        margin: theme.spacing(0, 3),
      },
      "& > div": {
        gap: theme.spacing(2),
        justifyContent: "flex-end",
      },
    },
    gridContainer: {
      alignItems: "start",
      fontWeight: 500,
      flexWrap: "nowrap",
      gap: theme.spacing(12),
    },
    gridChild: {
      background: theme.white50,
      border: `1px solid ${theme.gray200}`,
      borderRadius: 8,
      boxShadow: "0px 1px 1px rgba(154, 147, 147, 0.25)",
      display: "flex",
      flexDirection: "column",
    },
    content: {
      boxShadow: `0px 1px 0px ${theme.gray100}`,
      display: "flex",
      fontSize: 14,
      fontWeight: 500,
      gap: theme.spacing(10),
      justifyContent: "space-between",
      padding: theme.spacing(8, 12),
    },
    firstItem: {
      background: theme.gray50,
      boxShadow: `0px 1px 0px ${theme.gray200}`,
      color: theme.gray800,
      marginTop: "1px",
      padding: theme.spacing(6, 8),
    },
    ruleWrapper: {
      alignItems: "center",
      display: "flex",
    },
    rules: {
      display: "flex",
      flexDirection: "column",
      gap: theme.spacing(5),
    },
    conditionsInfo: {
      display: "flex",
      gap: theme.spacing(10),
      justifyContent: "space-between",
      padding: theme.spacing(8, 0, 0, 12),
    },
    rulesHeader: {
      color: theme.gray800,
      display: "flex",
      flexDirection: "column",
      gap: 4,
    },
    ruleName: {
      fontWeight: 600,
    },
    ruleDescription: {
      fontSize: 12,
      fontWeight: 400,
    },
    chips: {
      backgroundColor: theme.primary500,
      borderRadius: 32,
      color: theme.white50,
      fontSize: 12,
      padding: theme.spacing(2, 4),
    },
    tooltipIcon: {
      color: theme.gray500,
      height: "18px",
      opacity: 0.5,
      width: "18px",
    },
    tooltipTitle: {
      color: theme.gray800,
      fontSize: "14px",
      fontWeight: 500,
      lineHeight: "24px",
    },
    tooltipContent: {
      color: theme.gray500,
      fontSize: 12,
      lineHeight: "20px",
      marginTop: theme.spacing(2),
    },
    vectorMargin: {
      margin: theme.spacing(-7, 0, 0, 2),
    },
    link: {
      display: "flex",
      alignItems: "center",
      marginRight: theme.spacing(12),
      "& > svg": {
        marginLeft: theme.spacing(2),
        width: "14px",
        height: "14px",
      },
    },
  }),
);
